import "./FlagControl.scss";
import React, { useCallback } from "react";

import Select from "../../form/Select/Select";
import { useFlag } from "../../../lib/hook/MiscHooks";
import { TextElement } from "../../../lib/util/LocaleUtils";
import { Flag } from "../../../lib/Flags";

export interface FlagControlProps {
	label: TextElement;
	flag: Flag<any>;
	checkbox?: boolean;
	value?: any;
	onChange?: (event: any) => void;
}

const FlagControl = (props: FlagControlProps) => {
	const { label, flag, checkbox, value, onChange } = props;

	const handleChange = useCallback(
		(opt: any) => {
			const value = opt && opt.value;
			flag.set(value);
			if (onChange) {
				onChange(value);
			}
		},
		[flag, onChange],
	);

	const handleCheck = useCallback(
		(e: any) => {
			const value = e.target.checked;
			flag.set(value);
			if (onChange) {
				onChange(value);
			}
		},
		[flag, onChange],
	);

	useFlag(flag);

	let current = flag.get();
	if (!checkbox && typeof current !== "boolean") {
		current = null;
	}

	if (typeof value === "boolean") {
		current = value;
	}

	if (checkbox) {
		return (
			<>
				<label>{label}</label>
				<input
					checked={current}
					type={"checkbox"}
					disabled={typeof value === "boolean" || flag.isOverridden()}
					onChange={handleCheck}
				/>
			</>
		);
	}

	const options = [
		{
			label: `default (${flag.defaultValue ? "on" : "off"})`,
			value: null,
		},
		{
			label: "force off",
			value: false,
		},
		{
			label: "force on",
			value: true,
		},
	];

	return (
		<div className={"FlagControl"}>
			<Select
				fixed={true}
				label={label}
				dev={true}
				inline={true}
				disabled={typeof value === "boolean" || flag.isOverridden()}
				options={options}
				value={current}
				onChange={handleChange}
			/>
		</div>
	);
};

export default React.memo(FlagControl);
